//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            showDefaultModal: false,
            showCategories: false,
            subject: '',
            selectedCategory: 'Select Category',
            ccCategories: ["A/R", "One Time/Per Incident", "Monthly", "Volume Based"],
            sfCategories: ["One Time/Per Incident", "Monthly", "Volume Based"]
        };
    },
    created: function created() {
        var _this = this;

        //allows modal to be dismissed on escape key
        document.addEventListener('keydown', function (e) {
            if (e.key == 'Escape' && _this.showDefaultModal) {
                _this.showDefaultModal = false;
            }
        });
    },
    mounted: function mounted() {
        var _this2 = this;

        var $el = this;

        Event.$on('global-defaults-modal-close', function () {
            _this2.showDefaultModal = false;
        });
        Event.$on('show-defaults-modal', function ($args, $subject) {
            $el.showDefaultModal = true;
            $el.selectedCategory = $args;
            $el.subject = $subject;
        });
    },

    methods: {
        close: function close() {
            Event.$emit('global-defaults-modal-close');
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/settings/GlobalDefaultsModal.vue
// module id = VMBk
// module chunks = 0 1